import React from 'react';
import { IPageListRendererProps } from 'react-bootstrap-table2-paginator';
import styled from 'styled-components';
import { PageButtonRenderer } from './PageButtonRenderer';

const StyledPageList = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: end;
  padding: ${(props) => `${props.theme.spacing.spacing5} 0`};
`;

export const PageListRenderer: React.FC<IPageListRendererProps> = ({ pages, onPageChange }) => {
  return (
    <StyledPageList>
      {pages.map((props) => (
        <PageButtonRenderer key={props.page} {...props} onPageChange={onPageChange} />
      ))}
    </StyledPageList>
  );
};
